export const GET_EXTRA_STAFFING_DATA: string = "GET_EXTRA_STAFFING_DATA";
export const LOADING: string = "LOADING";